import React from "react";
import PropTypes from "prop-types";

import {getAddressFromObject} from "./printDocumentInfo";


const PrintDocumentInfoCustomer = (props) => {
  const {styles, userInfo, fabricatorData, assignQuotePopupCustomer, employeeSelected, messages, paymentState, 
    isDealerFlow, isStoreInformation} = props;

  const {View, Text} = window.ReactPdfRenderer;

  const customerName = paymentState.shippingAddress && (paymentState.shippingAddress.name || paymentState.shippingAddress.fullName)
    ? paymentState.shippingAddress.name || paymentState.shippingAddress.fullName
    : assignQuotePopupCustomer
      ? assignQuotePopupCustomer.fullName
      : userInfo.firstName + (userInfo.lastName ? (" " + userInfo.lastName) : "");
  const customerEmail = isDealerFlow || (fabricatorData.receiptSettings && fabricatorData.receiptSettings.hideReceiptEmails)
    ? ""
    : assignQuotePopupCustomer ? assignQuotePopupCustomer.email : userInfo.email || "";
  const customerPhone = isDealerFlow ? "" : userInfo.phoneNumber
    ? userInfo.country && !userInfo.phoneNumber.includes(`+${userInfo.country.dialCode} `)
      ? `+${userInfo.country.dialCode} ${userInfo.phoneNumber}`
      : userInfo.phoneNumber
    : "";
  const mainAddress = isDealerFlow || paymentState.shippingAddress.address1 ? paymentState.shippingAddress.address1 : userInfo.address1;
  const customerAddress = isDealerFlow || paymentState.shippingAddress.address1
    ? getAddressFromObject(paymentState.shippingAddress)
    : getAddressFromObject(userInfo);
  const customerHasShippingAddress = userInfo.shipping && (["address1", "city", "postal"].some(key => {
    return userInfo.shipping[key] && (userInfo[key] !== userInfo.shipping[key])
  }));
  const threeColumns = (employeeSelected || (customerHasShippingAddress && !fabricatorData.isCaesarStone))
    && !fabricatorData.isAmericanStandard && !isDealerFlow;

  return (
    <View style={threeColumns ? [styles.section, styles.sectionLeft] : [styles.sectionTwo, styles.sectionLeft]}>
      <Text style={styles.mainTitle}>
        {isStoreInformation
          ? messages["receipt.mainInfo.fabricatorInformation"]
          : messages["receipt.mainInfo.customerInformation"]}
      </Text>
      <Text style={styles.mainText}>{customerName}</Text>
      {mainAddress ? <Text style={styles.mainText}>{mainAddress}</Text> : null}
      {customerAddress ? <Text style={styles.mainText}>{customerAddress}</Text> : null}
      {customerEmail ? <Text style={[styles.mainText, styles.mainTextEmail]}>{customerEmail}</Text> : null}
      {customerPhone ? <Text style={styles.mainText}>{customerPhone}</Text> : null}
    </View>
  )
};

PrintDocumentInfoCustomer.propTypes = {
  userInfo: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  assignQuotePopupCustomer: PropTypes.object,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentInfoCustomer
